import React from "react";
import "./common.scss";
import { Link } from "react-router-dom";
interface IProps {
  title: string;
  text: string;
  link?: string;
}
function AlertCard({ title, text, link }: IProps): React.ReactElement {
  return (
    <div className="alert__card">
      <div className="row">
        <div className="col col-lg-6">
          <h3 className="heading3">{title}</h3>
          <p className="text">{text}</p>
        </div>
        <div className="col col-lg-6 d-flex flex-column align-items-md-end gap-2">
          <Link to={link || "#"}>
            <button className="button">Add an endorsement</button>
          </Link>
          <p className="text">Add your new Endorsement</p>
        </div>
      </div>
    </div>
  );
}

export default AlertCard;
